<template>
  <div class="about">
    <PageGuide
      description="This page provides general information about the ORFanID application."
      :steps="[
        'Read the page overview to understand the purpose of ORFanID.',
        'Use the main navigation to access sequence submission, results, instructions, ORFanBase, or accession search.',
        'Return to the home page when you want to start from the ORFanID introduction.'
      ]"
    />
  </div>
</template>

<script>
export default {
  name: "About",
  metaInfo: {
    title: 'About | ORFanID',
    meta: [
      { name: 'description', content: 'About the ORFanID application and general information.' }
    ]
  }
};
</script>
